<template>
  <div>

    <span
        class="btn btn-light float-right"
        @click="showCreateModal"
        qid="measures-category-create-button"
    >
      <font-awesome-icon icon="plus-circle"/>
      {{ $t('system.create_new') }}
    </span>


    <!-- Create measure -->
    <b-modal ref="create-measure" hide-footer size="xl">
      <div class="d-block text-center">
        <h4 qid="update-p-title">
          {{ $t('maintenance.measures.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="formSubmit" qid="create-p-form">
        <div class="form-container">
          <div class="row">
            <div class="col-sm-6 pl-5 pr-3">
              <b-form-group>
                <label qid="create-p-name-label">
                  {{ $t('maintenance.measures.create.name_label') }}
                </label>
                <span class="text-red">*</span>
                <b-form-input
                  qid="create-p-form-name"
                  type="text"
                  v-model="pForm.name"
                  required
                  :maxLength="255"
                  :placeholder="$t('maintenance.measures.create.name_placeholder')"
                ></b-form-input>
              </b-form-group>
              <b-form-group>
                <label qid="create-ac-pg-label">
                  {{ $t('maintenance.measures.create.category_label') }}
                </label>
                <span class="text-red">*</span>
                <div class="row">
                  <div class="col-sm-8">
                    <multiselect
                        v-model="selectedCategory"
                        :options="categoryItems"
                        :placeholder="$t('maintenance.measures.create.category_placeholder')"
                        label="name"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        @search-change="loadCategories"
                        track-by="slug"
                        qid="create-ac-form-ac"
                    ></multiselect>
                  </div>
                  <div class="col-sm-4">
                    <MeasureCategoryCreateForm @reloadContent="updateCategories"></MeasureCategoryCreateForm>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-description-label">
                  {{ $t('maintenance.measures.create.description_label') }}
                </label>
                <b-form-textarea
                  qid="create-p-form-description"
                  v-model="pForm.description"
                  rows="6"
                  max-rows="6"
                  :placeholder="$t('maintenance.measures.create.description_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-attachments-label">
                  {{ $t('maintenance.measures.create.attachments') }}
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
                </label>
                <br>
                <p v-for="file in getFiles" :key="file.name">{{ file.name }}</p>
                <label class="btn btn-secondary cursor-pointer" qid="create-p-attachments-button">
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file-p"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-link-label">
                  {{ $t('maintenance.measures.create.links_label') }}
                </label>
                <p v-for="(link, index) in pForm.links">
                  <span class="float-right text-muted cursor-pointer"
                        @click="removeLinkItem(index)"
                        qid="create-p-link-remove"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <a :href="link.url" target="_blank" qid="create-p-link-item">{{ link.name ? link.name : link.url }}</a>
                </p>
                <div>
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                </div>
                <span class="btn btn-link cursor-pointer float-right"
                      @click="handleLink"
                      qid="create-p-add-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
              </b-form-group>
            </div>


            <div class="col-sm-6 pl-3 pr-5">
              <b-form-group>
                <label qid="create-p-implementation-status-label">
                  {{ $t('maintenance.measures.create.value_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="pForm.value"
                    :options="valueItems"
                    :placeholder="$t('maintenance.measures.create.value_placeholder')"
                    label="name"
                    @select="valueSelected"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-p-form-implementation-status"
                ></multiselect>
              </b-form-group>
              <b-form-group v-if="pForm.value && pForm.value.value == 'number'">
                <label qid="create-p-implementation-status-label">
                  {{ $t('maintenance.measures.create.currency_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="pForm.currency"
                    :options="currencyItems"
                    :placeholder="$t('maintenance.measures.create.currency_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-p-form-implementation-status"
                ></multiselect>
              </b-form-group>

              <b-form-group v-if="pForm.value && pForm.value.value == 'dropdown'">
                <label qid="create-p-pg-label">
                  {{ $t('maintenance.measures.values.dropdown_type') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="responseType"
                    :options="responseTypes"
                    :placeholder="$t('maintenance.questions.create.type_placeholder')"
                    label="name"
                    @select="handleType"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="create-p-form-pg"
                ></multiselect>
              </b-form-group>

              <b-form-group v-if="responseType && responseType.value == 'Select' && pForm.value && pForm.value.value == 'dropdown'">
                <label qid="create-p-link-label">
                  {{ $t('maintenance.questions.create.options_label') }}
                </label>
                <span class="text-red">*</span>
                <p v-for="(option, index) in selectedOptions">
                  <span class="float-right text-muted cursor-pointer"
                        @click="removeOptionItem(index, option)"
                        qid="create-p-link-remove"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span>{{ option }}</span>
                </p>
                <div class="input-group">
                  <b-form-input
                    qid="create-p-form-link"
                    type="text"
                    v-if="showInput"
                    v-on:keydown.enter="handleOption"
                    v-model="inputOption"
                    :placeholder="$t('maintenance.questions.create.options_placeholder')"
                  ></b-form-input>
                  <div class="input-group-append" v-if="showInput">
                    <span class="input-group-text cursor-pointer"
                          id="inputGroup"
                          @click="handleOption"
                          qid="handle-link-save"
                    >
                      {{ $t('system.save') }}
                    </span>
                  </div>
                </div>
                <span class="btn btn-link cursor-pointer float-right"
                      @click="showInput = true"
                      v-if="!showInput"
                      qid="create-p-add-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('maintenance.questions.create.add_option_label') }}
                </span>
              </b-form-group>

            </div>
          </div>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideCreateModal"
                    qid="edit-p-cancel-button"
          >
            {{ $t('maintenance.measures.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.measures.create.submit') }}
          </b-button>
        </div>
      </b-form>

    </b-modal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import MeasureCategoryCreateForm from '@/views/Measures/MeasureCategoryCreateForm.vue'


  export default {
    name: 'MeasureCreateForm',
    data: function() {
      return {
        pForm: {
          name: '',
          description: '',
          measure_category: [],
          value: [],
          currency: [],
          client:'',
          links: []
        },
        error: '',
        inputLink: '',
        inputLinkName: '',
        selectedFiles: [],
        categoryItems: [],
        categoryInput: '',
        selectedCategory: [],
        valueItems: [
          { name: this.$t('maintenance.measures.values.none'), value: 'none' },
          { name: this.$t('maintenance.measures.values.date'), value: 'date' },
          { name: this.$t('maintenance.measures.values.number'), value: 'number' },
          { name: this.$t('maintenance.measures.values.dropdown'), value: 'dropdown' }
        ],
        value: [],
        currencyItems: [
          {name: 'None', value: 'None'},
          {name: 'DKK', value: 'DKK'},
          {name: 'EUR', value: 'EUR'},
          {name: 'GBP', value: 'GBP'},
          {name: 'USD', value: 'USD'}
        ],
        responseTypes: [
          { name: this.$t('maintenance.questions.type.yes/no'), value: 'Yes/No' },
          { name: this.$t('maintenance.questions.type.select'), value: 'Select' }
        ],
        yesNoOptions: [
          'Yes',
          'No'
        ],
        responseType: [],
        selectedOptions: [],
        inputOption: '',
        positiveAnswers: [],
        negativeAnswers: [],
        allAnswers: [],
        allAnswersCopy: [],
        showInput: true,
        currency: [],
        buttonDisabled: false
      }
    },
    props: {

    },
    components: {
      Avatar,
      MeasureCategoryCreateForm
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getFiles() {
        return this.selectedFiles
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
      }
    },
    methods: {
      showCreateModal() {
        this.pForm.name = ''
        this.pForm.scope = []
        this.pForm.links = []
        this.pForm.value = []
        this.pForm.currency = []
        this.pForm.description = ''
        this.selectedScopes = []
        this.selectedFiles = []
        this.responseType = []
        this.selectedOptions = []
        this.inputOption = ''
        this.positiveAnswers = []
        this.allAnswers = []
        this.allAnswersCopy = []
        this.showInput = true
        this.currency = []
        this.selectedCategory = []
        this.loadCategories();
        this.error = ''
        this.$refs['create-measure'].show()
      },
      hideCreateModal() {
        this.pForm.name = ''
        this.pForm.scope = []
        this.$refs['create-measure'].hide()
      },
      handleType(value) {
        this.positiveAnswers = []
        this.negativeAnswers = []
        if (value && value.value == 'Select') {
          this.allAnswers = this.selectedOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        } else {
          this.allAnswers = this.yesNoOptions
          this.allAnswersCopy = _.cloneDeep(this.allAnswers);
        }
      },
      valueSelected(value) {
        if (value.value != 'dropdown') {
          this.selectedOptions = []
          this.responseType = []
        }
      },
      handleOption(evt) {
        evt.preventDefault();
        // If there's a link in input, add it to links array
        if (this.inputOption !== '') {
          this.selectedOptions.push(this.inputOption)
          // Reset link input form
          this.inputOption = ''
        }
        this.showInput = false;
      },
      removeOptionItem(index, item) {
        let positiveIndex = _.findIndex(this.positiveAnswers, function(answer) { return answer == item })
        let negativeIndex = _.findIndex(this.negativeAnswers, function(answer) { return answer == item })

        this.selectedOptions.splice(index, 1);

        if (!this.selectedOptions.length) {
          this.showInput = true;
        }

        if (positiveIndex != -1) {
          this.positiveAnswers.splice(positiveIndex, 1)
        }
        if (negativeIndex != -1) {
          this.negativeAnswers.splice(negativeIndex, 1)
        }
      },
      handleAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index != -1) {
          this.allAnswersCopy.splice(index, 1)
        }
      },
      expandAvailableAnswers(answer) {
        let index = _.findIndex(this.allAnswersCopy, function(item) { return answer == item })
        if (index == -1) {
          this.allAnswersCopy.push(answer)
        }
      },
      resetFile() {
        let imagefile = document.querySelector('#file-p');
        imagefile.value = '';
      },
      handleCategoryInput(input) {
        this.categoryInput = input;
      },
      onFileChange() {
        let files = document.querySelector('#file-p');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.pForm.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.pForm.links.splice(index, 1);
      },
      formSubmit(evt) {
        let formData = new FormData();
        let files = document.querySelector('#file-p');
        let sizeError = false;

        // Call handle link function to gather link from link input
        this.handleLink()

        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        // Append list of attachments to FormData
        for (var i = 0; i < files.files.length; i++) {
          // Equal to 10 MB
          if (files.files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append("files[]", files.files[i]);
        }

        // Append list of links to FormData
        for (var i = 0; i < this.pForm.links.length; i++) {
          formData.append("links[]", JSON.stringify(this.pForm.links[i]));
        }

        if(this.selectedCategory.id){
          formData.append("measure_category_id", this.selectedCategory.id);
        }


        // Additional check - if implementation status is selected, append it to form data
        if (this.pForm.value && this.pForm.value.value) {
          formData.append("value", this.pForm.value.value);
        }

        if (this.pForm.currency && this.pForm.currency.value) {
          formData.append("currency", this.pForm.currency.value);
        }

        if (this.responseType && this.responseType.value) {
          formData.append("type", this.responseType.value);
        }

        if (this.selectedOptions && this.selectedOptions.length) {
          formData.append("type_options", JSON.stringify(this.selectedOptions))
        }

        if (this.positiveAnswers && this.positiveAnswers.length) {
          formData.append("type_positive_response", JSON.stringify(this.positiveAnswers))
        }

        formData.append("name", this.pForm.name);
        formData.append("description", this.pForm.description);
        formData.append("client", this.getClient.slug);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          if (
            (this.selectedCategory && this.selectedCategory.id) &&
            (this.pForm.value && this.pForm.value.value) &&
            (
              (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value) ||
              ((this.pForm.value.value == 'dropdown' && this.responseType && this.responseType.value && ((this.responseType && this.responseType.value == 'Yes/No') || (this.responseType && this.responseType.value == 'Select' && this.selectedOptions && this.selectedOptions.length))) || (this.pForm.value.value == 'number' && this.pForm.currency && this.pForm.currency.value)) ||
              this.pForm.value.value == 'date' || this.pForm.value.value == 'none'
            )
          ){
            this.buttonDisabled = true;
            // Post FormData object to API
            piincHttp.post('/measures', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
              self.$toastr('success', self.$t('maintenance.measures.create.success'))
              self.buttonDisabled = false;
              self.hideCreateModal();
              self.$emit('reloadContent', response.data);
            }, function(error) {
              if (error.status !== 200) {
                self.buttonDisabled = false;
                self.error = error.data.message;
                if (error.data.errors['files.0']) {
                  self.error += ' ' + error.data.errors['files.0'][0]
                }
              }
            })
          } else {
            this.error = ''

            if (!this.selectedCategory || !this.selectedCategory.id) {
              this.error +=  ' ' + this.$t('system.category_error_message')
            }
            if (!this.pForm.value || (this.pForm.value && !this.pForm.value.value)) {
              this.error +=  ' ' + this.$t('system.value_error_message')
            }
            if ((this.pForm.value && this.pForm.value.value == 'dropdown') && this.responseType && !this.responseType.value) {
              this.error +=  ' ' + this.$t('system.response_type_error_message')
            }
            if ((this.pForm.value && this.pForm.value.value == 'number') && this.pForm.currency && !this.pForm.currency.value) {
              this.error +=  ' ' + this.$t('system.currency_error_message')
            }
            if ((this.responseType && this.responseType.value == 'Select') && this.selectedOptions && !this.selectedOptions.length) {
              this.error +=  ' ' + this.$t('system.selected_options_error_message')
            }
          }

        }
      },
      updateCategories(object) {
        this.loadCategories()
      },
      loadCategories(searchQuery) {
        let self = this;
        piincHttp.get('measure-categories', { params:
          {
            client: this.getClient.slug,
            keyword: searchQuery !== '' ? searchQuery : undefined,
            per_page: 100
          }
        }).then(function(response) {
          self.categoryItems = response.data.items
          if (self.categoryItems && !self.categoryItems.length) {
            self.categoryItems.push({category: self.$t('system.no_results'), $isDisabled: true})
          }
        }, function() {});
      }
    },
    created () {
      if (this.getClient && this.getClient.slug) {

      }
    }
  }
</script>
